import { collection, doc, getDocs, getFirestore, query, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { derived, writable } from 'svelte/store';
import dayjs from 'dayjs';
import { getAuth } from 'firebase/auth';
import useLocalStorage from '../hooks/useLocalStorage';
let db = undefined;
let userRef = undefined;
let gameRef = undefined;
let timer = undefined;
let localStore = undefined;
export const score = writable(0);
export const words = writable([]);
export const seconds = writable(60 * 3); // 3 minutes for boggle
export const gameDice = writable([]);
export const hourglass = derived(seconds, ($seconds) => new Date($seconds * 1000).toISOString().substr(14, 5));
export const setupBoogleGame = async (dice, hash) => {
    if (!localStore)
        localStore = useLocalStorage(hash);
    // setup firestore
    if (!db)
        db = getFirestore();
    let challengeRef = undefined;
    if (hash) {
        const challengeQuery = query(collection(db, 'challenge'), where("hashLink", '==', hash));
        const challengeSnapshot = await getDocs(challengeQuery);
        if (!challengeSnapshot.empty) {
            challengeSnapshot.forEach(doc => {
                challengeRef = doc.ref;
            });
        }
    }
    const userId = getAuth().currentUser.uid;
    userRef = doc(db, 'users', userId);
    let gameQuery = undefined;
    if (challengeRef)
        gameQuery = query(collection(db, 'boggle'), where("player", '==', userRef), where("challenge", '==', challengeRef));
    else
        gameQuery = query(collection(db, 'boggle'), where("player", '==', userRef), where("ref", '==', dayjs().format('YYYYMMDD')));
    const querySnapshot = await getDocs(gameQuery);
    if (querySnapshot.empty) {
        gameRef = doc(collection(db, "boggle"));
        await setDoc(gameRef, {
            words: [],
            player: userRef,
            ref: challengeRef ? null : dayjs().format('YYYYMMDD'),
            seconds: 60 * 3,
            score: 0,
            challenge: challengeRef || null,
            created: serverTimestamp(),
            dice: dice,
        });
        gameDice.update(() => dice.split(','));
    }
    else {
        querySnapshot.forEach(doc => {
            gameRef = doc.ref;
            const data = doc.data();
            words.update(() => data.words);
            seconds.update(() => data.seconds);
            score.update(() => data.score);
            gameDice.update(() => data.dice.split(','));
        });
    }
    startBoggleGame();
};
export const startBoggleGame = async () => {
    console.log('start boggle');
    if (!timer) {
        timer = setInterval(() => {
            let lsec = undefined;
            seconds.update(sec => {
                let s = sec;
                if (sec > 0) {
                    s = sec -= 1;
                    localStore.add('seconds', s);
                }
                lsec = s;
                return s;
            });
            if (lsec <= 0) {
                clearInterval(timer);
                saveBoggleGame();
            }
        }, 1000);
    }
};
export const pauseBoggleGame = () => {
    clearInterval(timer);
    saveBoggleGame();
};
export const saveBoggleGame = async () => {
    let wrds = undefined;
    let scr = undefined;
    let sec = undefined;
    words.update(words => {
        wrds = words;
        return words;
    });
    const time = new Date().getTime();
    localStore.add('time', time);
    score.update(score => {
        scr = score;
        return score;
    });
    seconds.update(seconds => {
        sec = seconds;
        return seconds;
    });
    if (db && gameRef) {
        setDoc(gameRef, {
            words: wrds,
            score: scr,
            seconds: sec,
        }, { merge: true });
    }
};
